import { ActionTypes } from './types'

/// /////////////////////////////////////////////////////////////////////
export const SetIsWorthy = () => ({ type: ActionTypes.SET_IS_WORTHY })
